<template>
    <x-page :title="pageTitle">
        <template #header-actions>
            <x-back-button :disabled="isLoading" :display-warning="false" />
        </template>
        <metric-form id="metric-form"
            v-if="resource"
            :disabled="true"
            :initialFields="resource" />
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import { handleGeneralXhrError } from '../../helpers'
import MetricForm from './MetricForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        MetricForm,
    },
    computed: {
        pageTitle() {
            return `Master Metric | ${this.resource?.name}`
        }
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/metrics/${this.$route.params.id}`, {
                params: {
                    load: 'category'
                }
            })
            .then(response => {
                this.resource = response.data.data
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
    },
}
</script>